<template>
    <div>
        <div>
            <el-form label-position="right" label-width="120px">
                <el-form-item label="筛选学校">
                    <el-select v-model="$parentInfo.dialog_StoreStudentDeposit.filter.school_id"
                               clearable placeholder="请选择学校"
                               filterable remote
                               style="width: 200px;"
                               :remote-method="handleSearchSchool" @change="handleStudent()">
                        <el-option
                                v-for="item in $parentInfo.schools"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="筛选年级">
                    <el-select v-model="$parentInfo.dialog_StoreStudentDeposit.filter.grade_id"
                               clearable placeholder="请选择年级"
                               style="width: 200px;"
                               @change="handleStudent()">
                        <el-option
                                v-for="item in $parentInfo.grades"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="筛选班主任">
                    <el-select v-model="$parentInfo.dialog_StoreStudentDeposit.filter.headTeacher_id"
                               clearable placeholder="请选择班主任" filterable remote
                               style="width: 200px;"
                               :remote-method="handleSearchHeadTeacher" @change="handleStudent()">
                        <el-option
                                v-for="item in $parentInfo.headTeachers"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="筛选学号">
                    <el-select v-model="$parentInfo.dialog_StoreStudentDeposit.filter.student_id"
                               clearable placeholder="请选择学号" filterable remote
                               style="width: 200px;"
                               :remote-method="handleSearchStudentId" @change="handleStudent()">
                        <el-option
                                v-for="item in $parentInfo.student_ids"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="筛选学生手机号">
                    <el-select v-model="$parentInfo.dialog_StoreStudentDeposit.filter.student_phone_id"
                               clearable placeholder="请选择学生手机号" filterable remote
                               style="width: 200px;"
                               :remote-method="handleSearchStudentPhone" @change="handleStudent()">
                        <el-option
                                v-for="item in $parentInfo.phones"
                                :key="item.id"
                                :label="item.phone"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="学生">
                    <el-select v-model="$parentInfo.dialog_StoreStudentDeposit.filter.student_name_id"
                               clearable placeholder="请选择学生姓名" filterable remote
                               style="width: 200px;"
                               :remote-method="handleSearchStudentName" @change="handleStudent()">
                        <el-option
                                v-for="item in $parentInfo.students"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="$parentInfo.dialog_StoreStudentDeposit.filter.remark" size="small"
                              type="textarea"
                              placeholder="押金来源" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="金额">
                    <el-input-number :min="0" v-model="$parentInfo.dialog_StoreStudentDeposit.filter.balance" size="small"></el-input-number>
                </el-form-item>
            </el-form>
        </div>
        <div class=" text-right">
            <el-button type="primary" @click="handleStoreDeposit()"
                       :loading="$parentInfo.dialog_StoreStudentDeposit.button_loading">保存
            </el-button>
        </div>
    </div>

</template>

<script>
    export default {
        name: "Dialog_StoreStudentDeposit",
        data() {
            return {
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        methods: {
            handleStudent(){
                this.$wApi.send(this.$parentInfo.path, 'search_student', {
                    'filter':this.$parentInfo.dialog_StoreStudentDeposit.filter
                })
            },
            handleSearchSchool(query) {
                this.$wApi.send(this.$parentInfo.path, 'search', {
                    'type':'searchSchool',
                    'schoolKeyName': query,
                })
            },
            handleSearchHeadTeacher(query) {
                this.$wApi.send(this.$parentInfo.path, 'search', {
                    'type':'headTeacherKeyName',
                    'headTeacherKeyName': query,
                })
            },
            handleSearchStudentId(query){
                this.$wApi.send(this.$parentInfo.path, 'search', {
                    'type':'studentKeyId',
                    'studentKeyId': query,
                })
            },
            handleSearchStudentName(query){
                this.$wApi.send(this.$parentInfo.path, 'search', {
                    'type':'studentKeyName',
                    'studentKeyName': query,
                })
            },
            handleSearchStudentPhone(query){
                this.$wApi.send(this.$parentInfo.path, 'search', {
                    'type':'studentKeyPhone',
                    'studentKeyPhone': query,
                })
            },
            handleStoreDeposit(){
                this.$wApi.send(this.$parentInfo.path, 'store_student_deposit', {
                    'student_id':this.$parentInfo.dialog_StoreStudentDeposit.filter.student_name_id,
                    'remark':this.$parentInfo.dialog_StoreStudentDeposit.filter.remark,
                    'balance':this.$parentInfo.dialog_StoreStudentDeposit.filter.balance
                })
            }
        }
    }
</script>

<style scoped>

</style>